const CBE_TIPO_RESP_INSCRIPTO = 1;

const CBE_TIPO_MONOTRIBUTISTA = 2;

export default {
  CBE_TIPO_RESP_INSCRIPTO: CBE_TIPO_RESP_INSCRIPTO,
  CBE_TIPO_MONOTRIBUTISTA: CBE_TIPO_MONOTRIBUTISTA,
};